import { useRecoilValue } from "recoil"
import signupStepState from "../../recoil/signupStep/atom"
import StepBoxItem from "./StepBoxItem"
import { styled } from "styled-components"

const StepBox = () => {
  const signupStep = useRecoilValue(signupStepState)

  const makeStepItems = (step: number) => {
    const items = []
    for (let i = 1; i < 4; i++) {
      if (i <= step) {
        items.push(<StepBoxItem key={`step-${i}`} isCompleted={true} />)
      } else {
        items.push(<StepBoxItem key={`step-${i}`} isCompleted={false} />)
      }
    }
    return items
  }
  return <StepBoxDiv>{makeStepItems(signupStep)}</StepBoxDiv>
}

export default StepBox

const StepBoxDiv = styled.div`
  display: flex;
  gap: 25px;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
`
